
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class LabelComparator extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) value!: number;
  @Prop({ default: false }) symbol!: string;
}
